const FetchStatusIdle = 'idle'
const FetchStatusLoading = 'loading'
const FetchStatusLoaded = 'loaded'
const FetchStatusError = 'error'

const FetchStatuses = [FetchStatusIdle, FetchStatusLoading, FetchStatusLoaded, FetchStatusError]

export const fetchStatuses = {
  FetchStatusIdle,
  FetchStatusLoading,
  FetchStatusLoaded,
  FetchStatusError,
  FetchStatuses
}

export default {
  data: function () {
    return {
      FetchStatusIdle,
      FetchStatusLoading,
      FetchStatusLoaded,
      FetchStatusError,
      FetchStatuses
    }
  }
}
